const FeaturesSection = () => {
  return (
    <section
      id="features"
      className="relative -mt-36 pt-36 pb-16 overflow-hidden"
    >
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h1
            data-aos="fade-up"
            className="font-heading text-4xl lg:text-5xl font-bold text-gray-100 mb-24"
          >
            <span>Why Choose</span>{" "}
            <span className="text-color">SoftStake?</span>
          </h1>
        </div>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">
            <div
              className="col pb-10 lg:pb-0 border-b border-gray-800 lg:border-b-0"
              data-aos="fade-up"
            >
              <div className="mx-auto max-w-sm">
                <div className="flex pb-12 mb-12 border-b border-gray-800">
                  <div className="flex flex-shrink-0 w-14 h-14 mr-6 items-center justify-center bg-blue-100 rounded-full">
                    <img
                      src="https://shuffle.dev/saturn-assets/images/features/icon-element.svg"
                      alt="..."
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">
                      Effortless Staking
                    </h3>
                    <span className="text-sm text-gray-300">
                      Our user-friendly platform makes it easy to stake your
                      NFTs in just a few clicks. No technical expertise
                      required.
                    </span>
                  </div>
                </div>
                <div className="flex pb-12 mb-12 border-b border-gray-800">
                  <div className="flex flex-shrink-0 w-14 h-14 mr-6 items-center justify-center bg-orange-100 rounded-full">
                    <img
                      src="https://shuffle.dev/saturn-assets/images/features/icon-hierarchy.svg"
                      alt="..."
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">High Rewards</h3>
                    <span className="text-sm text-gray-300">
                      Earn competitive rewards and watch your NFT portfolio
                      grow. We offer some of the highest returns in the market.
                    </span>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex flex-shrink-0 w-14 h-14 mr-6 items-center justify-center bg-gray-300 rounded-full">
                    <img
                      src="https://shuffle.dev/saturn-assets/images/features/icon-school-bag.svg"
                      alt="..."
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">
                      Secure and Reliable
                    </h3>
                    <span className="text-sm text-gray-300">
                      Your assets' security is our top priority. Our robust
                      platform ensures your NFTs are safe and secure.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col hidden lg:block">
              <img
                className="block h-80 md:h-100 lg:h-auto xl:h-150 mx-auto"
                src="/assets/images/3d-nft-machine.png"
                alt="..."
                data-aos="zoom-in"
                data-aos-delay="200"
              />
            </div>
            <div className="col" data-aos="fade-up" data-aos-delay="100">
              <div className="mx-auto max-w-sm">
                <div className="flex pb-12 mb-12 border-b border-gray-800">
                  <div className="flex flex-shrink-0 w-14 h-14 mr-6 items-center justify-center bg-red-200 rounded-full">
                    <img
                      src="https://shuffle.dev/saturn-assets/images/features/icon-robot.svg"
                      alt="..."
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">
                      Diverse NFT Support
                    </h3>
                    <span className="text-sm text-gray-300">
                      SoftStake supports a wide range of NFTs, from digital art
                      to collectibles. Stake any NFT you own.
                    </span>
                  </div>
                </div>
                <div className="flex pb-12 mb-12 border-b border-gray-800">
                  <div className="flex flex-shrink-0 w-14 h-14 mr-6 items-center justify-center bg-yellow-200 rounded-full">
                    <img
                      src="https://shuffle.dev/saturn-assets/images/features/icon-cam.svg"
                      alt="..."
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">
                      Transparent and Decentralized
                    </h3>
                    <span className="text-sm text-gray-300">
                      Our platform leverages blockchain technology for complete
                      transparency and decentralization, ensuring fair and open
                      staking processes.
                    </span>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex flex-shrink-0 w-14 h-14 mr-6 items-center justify-center bg-green-200 rounded-full">
                    <img
                      src="https://shuffle.dev/saturn-assets/images/features/icon-flask.svg"
                      alt="..."
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold">
                      Community and Support
                    </h3>
                    <span className="text-sm text-gray-300">
                      Join a vibrant community of NFT enthusiasts and get 24/7
                      support from our dedicated team.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
